import { Icon, Typography } from '@smartgift/frontend-toolkit';
import styled, { css } from 'styled-components';

const ToggleChildrenWrapper = styled.div`
  padding: 16px;
`;

const ToggleMenuContent = styled.div`
  @keyframes fadeIn-${({ menuId }) => menuId} {
    0% {
      height: 0;
    }
    100% {
      height: ${({ childHeight }) => childHeight};
    }
  }

  @keyframes fadeOut-${({ menuId }) => menuId} {
    0% {
      height: ${({ childHeight }) => childHeight};
    }
    100% {
      height: 0;
    }
  }

  animation: ${({ active, menuId }) => (active ? `fadeIn-${menuId}` : `fadeOut-${menuId}`)} 0.5s
    ease;
  height: ${({ active }) => (active ? '100%' : '0')};
  overflow: ${({ active, isAnimationFrameCompleted }) =>
    active && isAnimationFrameCompleted ? 'visible' : 'hidden'};
`;

const ToggleMenuHeader = styled.div`
  align-items: center;
  background-color: var(--color-accent-secondary-weakest);
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  padding: 12px;
  position: relative;

  ${({ disabled }) =>
    disabled &&
    css`
      opacity: 0.3;
    `}
  ${({ active }) =>
    active &&
    css`
      border-bottom: 1px solid var(--color-accent-secondary-weaker);
    `}

  ${Icon.S.Icon}:last-child {
    transition: all 0.3s ease-in-out;

    ${({ active }) => css`
      ${active &&
      css`
        transform: rotate(90deg);
      `}
    `}
  }
`;

const ToggleMenuTitle = styled.div`
  align-items: center;
  display: flex;
  gap: 4px;
`;
const AccordionIconWrapper = styled.div`
  align-items: center;
  display: flex;
`;

const ToggleMenu = styled.div`
  background-color: var(--color-bg-body);
  border: 1px solid var(--color-accent-secondary-weaker);
  border-radius: var(--size-border-radius-md);
  overflow: hidden;
`;

const ToggleMenuGroup = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  gap: 24px;
`;

const ToggleMenuGroupHeader = styled(Typography)`
  border-top: 1px solid #ececec;
  margin-top: 8px;
  padding-top: 16px;
`;

export {
  AccordionIconWrapper,
  ToggleChildrenWrapper,
  ToggleMenu,
  ToggleMenuContent,
  ToggleMenuGroup,
  ToggleMenuGroupHeader,
  ToggleMenuHeader,
  ToggleMenuTitle
};
